import { createContext } from "react";

export const VendorProfileFormDataContext = createContext(null);